import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
import {ValidationError} from "../lib/errors";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Category extends Base implements EntityType {
    categoryId: uuid;
    name: string;
    description?: string | null;
    relatedAreas: string[];
    constructor(doc: typeof Category | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            categoryId: genUUID(),
            name: null,
            relatedAreas: [],
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "category";
        // @ts-ignore
        this.categoryId = doc._categoryId || doc.categoryId || doc.categoryid || genUUID();
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.description = doc._description || doc.description || null;
        // @ts-ignore
        this.relatedAreas = doc._relatedAreas || doc.relatedAreas || doc.relatedareas || [];
    }
    get id(): uuid { return this.categoryId; }
    addRelatedArea(relatedArea: string): string {
        if (!relatedArea) throw new ValidationError('No nulls allowed in an array!');
        if (!this.relatedAreas) this.relatedAreas = [];
        this.relatedAreas.push(relatedArea);
        return relatedArea;
    }
    updateRelatedArea(relatedArea: string) {
        if (!this.relatedAreas) this.relatedAreas = [];
        const index = this.relatedAreas.findIndex(item => item === relatedArea);
        if (index !== -1) { this.relatedAreas[index] = relatedArea; }
        else this.addRelatedArea(relatedArea);
    }
    removeRelatedArea(relatedArea: string) {
        if (!this.relatedAreas) return;
        let foundItems = this.relatedAreas?.filter(item => item === relatedArea);
        if (foundItems && foundItems.length > 0) {
            this.relatedAreas = this.relatedAreas.filter(item => !(item === relatedArea));
        }
    }
    abandonRelatedAreas() { this.relatedAreas = []; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for the category"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","comment":"Associated firm"}]; }
    toLowerCase() { return this.categoryId; }
    static override getNonRefArrayFields(): string[] { return ["relatedAreas"]; }
    static override getDefaultEntries(): Category[] {
        return [{"categoryId":"c0f7b30a-dffb-451c-bfd4-b8f3bcb3b760","name":"Administrative","relatedAreas":["Administrative"],"status":"C"},{"categoryId":"bbf61f6b-e9fc-474e-bc4d-b27cf991940c","name":"Client","relatedAreas":["Client"],"status":"C"},{"categoryId":"cf62ad03-f7c4-46e7-9142-9682aec81a8e","name":"Financial","relatedAreas":["Financials"],"status":"C"},{"categoryId":"df601183-2985-4fa1-85f0-2b97e0699c9c","name":"Human Resources","relatedAreas":["Human Resources"],"status":"C"},{"categoryId":"90104e7f-6928-4eae-9b6e-a24aa748c4f2","name":"Marketing","relatedAreas":["Marketing"],"status":"C"},{"categoryId":"350d65fe-0dfc-4842-9dab-8a1fc88ae9d0","name":"Sales","relatedAreas":["Sales"],"status":"C"}].map(e => new Category(e));
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'category',
    dataArea: 'Firm Settings',
    table: 'CATEGORY',
    comment: 'A broad classification label applied to tasks and other records to indicate which area of the firm the work belongs to (e.g. Client, Financial, Marketing). Categories also drive downstream behavior: tasks assigned to a Client category are marked billable, and time logs are split across categories for reporting. There are two tiers: master categories managed by an admin that apply firm-wide, and personal categories created by individual users.',
    fields: {
        categoryId: {type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for the category'},
        name: {
            type: 'string', required: true, comment: 'Category name'
        },
        description: {
            type: 'string', required: false, comment: 'Category description'
        },
        relatedAreas: {
            type: 'string[]',
            required: true,
            comment: 'Areas of the system that this category related to, e.g. Marketing, Sales, Human Resources'
        }
    },
    sortOrder: [
        {position: 1, fieldName: 'first', asc: true},
        {position: 2, fieldName: 'description', asc: true}
    ],
    entries: [
        // Administrative
        {categoryId: 'c0f7b30a-dffb-451c-bfd4-b8f3bcb3b760', name: 'Administrative', relatedAreas: ['Administrative']},
        {categoryId: 'bbf61f6b-e9fc-474e-bc4d-b27cf991940c', name: 'Client', relatedAreas: ['Client']},
        {categoryId: 'cf62ad03-f7c4-46e7-9142-9682aec81a8e', name: 'Financial', relatedAreas: ['Financials']},
        {categoryId: 'df601183-2985-4fa1-85f0-2b97e0699c9c', name: 'Human Resources', relatedAreas: ['Human Resources']},
        {categoryId: '90104e7f-6928-4eae-9b6e-a24aa748c4f2', name: 'Marketing', relatedAreas: ['Marketing']},
        {categoryId: '350d65fe-0dfc-4842-9dab-8a1fc88ae9d0', name: 'Sales', relatedAreas: ['Sales']}
    ]
});
    }
}
export default Category;
